import React from 'react';
import './TrailerModal.css';

const TrailerModal = ({ isOpen, onClose, trailerUrl }) => {
  if (!isOpen || !trailerUrl) return null;

  // Convert YouTube URL to embed format with parameters to hide suggested content
  const getEmbedUrl = (url) => {
    if (!url) return '';
    
    // Extract video ID from various YouTube URL formats
    let videoId = '';
    
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('v=')[1]?.split('&')[0];
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1]?.split('?')[0];
    } else if (url.includes('embed/')) {
      videoId = url.split('embed/')[1]?.split('?')[0];
    }
    
    if (!videoId) return '';
    
    // Return embed URL with parameters to hide suggested content and controls
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&showinfo=0&controls=1&fs=1`;
  };

  const embedUrl = getEmbedUrl(trailerUrl);

  return (
    <div className="trailer-modal-overlay" onClick={onClose}>
      <div className="trailer-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="trailer-modal-close" onClick={onClose}>
          ✕
        </button>
        <div className="trailer-video-container">
          <iframe
            src={embedUrl}
            title="Movie Trailer"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="trailer-iframe"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default TrailerModal;


